import { API_BASE } from '../config/api';

const normalizeBase = (value) => String(value || '').trim().replace(/\/+$/, '');
const isLoopbackHost = (hostname) => ['localhost', '127.0.0.1', '::1'].includes(String(hostname || '').toLowerCase());
const isCanonicalUploadPath = (pathname) => String(pathname || '').startsWith('/uploads/');

export const resolveMediaUrlAgainstBase = (url, configuredBase = API_BASE) => {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  const base = normalizeBase(configuredBase);

  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const parsed = new URL(trimmed);
      if (isLoopbackHost(parsed.hostname) && isCanonicalUploadPath(parsed.pathname) && base) {
        return `${base}${parsed.pathname}${parsed.search}${parsed.hash}`;
      }
    } catch (_error) {
      return trimmed;
    }
    return trimmed;
  }
  if (/^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(trimmed)) return trimmed;

  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return base ? `${base}${path}` : path;
};

export const resolveMediaUrl = (url) => resolveMediaUrlAgainstBase(url, API_BASE);
